<template>
  <div class="paginated-list">
    <v-toolbar flat>
    <v-text-field
      name="busqueda_simple"
      v-model="search"
      label="Buscar"
      single-line
      prepend-icon="search"
      hide-details
      clearable
      :loading="loadingSearchDto"
      v-if="!noSearch && !searchFields"
      @keyup.enter.native="getItems()"
      style="width: 80%"
    ></v-text-field>
    <v-menu
      offset-y
      v-if="!noSearch && searchFields"
      v-model="showAdvanceSearch"
      :close-on-content-click="false"
      :open-on-click="false"
      style="width: 80%"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
                name="busqueda_avanzada"
                v-model="search"
                prepend-icon="search"
                label="Buscar"
                single-line
                hide-details
                clearable
                @keyup.enter.native="getItems()"
        >
          <template slot="append-outer">
            <v-chip
                    v-if="advanceFilterCount > 0"
                    close
                    @click:close="clearAdvanceSearch()"
            >{{filtersCountText}}</v-chip>
          </template>
          <template slot="append">
            <v-btn class="ma-0" icon text @click="onShowAdvanceSearch()">
              <v-icon>{{showAdvanceSearch ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </template>
      <v-card @keydown.esc="cancelSearchAdvance()">
        <v-form
            @submit.prevent="searchAdvance()">
          <v-container>
          <GenericForm
            v-if="searchFields"
            ref="advanceSearchForm"
            v-model="advanceSearchModel"
            :fields="searchFields"
          />
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="button" text @click="cancelSearchAdvance()">Cancelar</v-btn>
          <v-btn type="button" text @click="clearAdvanceSearch()">Limpiar</v-btn>
          <v-btn color="primary" type="submit" text>Buscar</v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-menu>
    <v-spacer></v-spacer>
      <v-btn
        v-if="generarCSV"
        text
        color="primary"
        title="Exportar"
        @click="descargarCSV()"
      >EXPORTAR</v-btn>
      <v-btn
        v-if="generarPDF"
        text
        color="primary"
        title="Descargar PDF"
        @click="descargarPDF()"
      >PDF</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="list"
      v-model="selected"
      :loading="loading || cargando"
      :server-items-length="totalCount"
      :options.sync="pagination"
      :class="`elevation-${elevation}`"
      :show-select="selectable"
      :items-per-page="itemsPerPageDefault"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageText:'Por página',
        'items-per-page-options' : rowsPerPageItems
      }"
      :locale="locale"
      fixed-header
    >
      <template v-slot:item="{ item, headers, index, isSelected, select }">
          <tr :disabled="loading" v-bind:style="{ color: item.color && rowColor ? $vuetify.theme.secondary : ''}">
            <td
                :key="header.value"
                  v-for="(header, idx) in headers"
                  @click="$emit('itemClick', {item: item, idx: index})"
                  v-longclick="() => onRowLongClick( {item: item, idx: index})"
                  v-bind:style="{ fontWeight: item.color && rowColor ? 'bold' : 'normal'}"
                >
                  <v-simple-checkbox
                      color="primary"
                      v-if="selectable && idx === 0"
                      v-model="isSelected" @input="select($event)"></v-simple-checkbox>
                  <v-tooltip bottom v-else-if="header.mostrarTooltip && item[tooltipTextProp]" right max-width="900px">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        tooltip
                        {{ header.format ? header.format(item[header.value]) : defaultRowFormat(item[header.value],
                        header) }}
                      </span>
                    </template>
                    <span>{{item[tooltipTextProp]}}</span>
                  </v-tooltip>
                  <template v-else>
                    {{ header.format ? header.format(item[header.value]) : defaultRowFormat(item[header.value],
                    header) }}
                  </template>
                </td>
                <td v-if="rowActions && rowActions.length > 0 && !$vuetify.breakpoint.xsOnly && !isPrincipalList">
                  <v-layout row>
                    <v-btn
                      v-for="action in rowActions"
                      icon
                      :key="action.name"
                      :title="action.name"
                      @click.native="$emit('itemAction', {item: item, idx: index, action: action.name})"
                    >
                      <v-icon>{{action.icon}}</v-icon>
                    </v-btn>
                  </v-layout>
                </td>
          </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="props"
      >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
      <template slot="no-data">
        <p class="text-xs-center" v-if="loading">{{loadingMessage}}</p>
        <p class="text-xs-center" v-else-if="!error && !search">{{noDataMessage}}</p>
        <p class="text-xs-center" v-else-if="!error && search">{{noSearchResultsMessage}}</p>
        <ErrorMessage v-else @refresh="getItems()" :message="errorMessage"/>
      </template>
    </v-data-table>
    <v-snackbar bottom left v-model="descargando">
      <v-progress-circular v-model="porcentajeDescarga" :indeterminate="totalDescarga === null"></v-progress-circular>Descargando documento
    </v-snackbar>
    <v-bottom-sheet v-model="sheet" v-if="rowActions && rowActions.length > 0">
      <v-list>
        <v-list-item
                v-for="action in rowActions"
                :key="action.name"
                @click="bottonSheetAction(action);sheet = false"
                flat
        >
          <v-list-item-icon>
            <v-icon medium>{{action.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            {{ action.name }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>
    <a hidden ref="fileAnchor"></a>
  </div>
</template>

<script>
  import ErrorMessage from './utils/ErrorMessage';
  import dateFiltersMixin from '../mixins/dateFiltersMixin';
  import debounce from 'lodash.debounce';
  import GenericForm from './generic-fields/GenericForm';
  import { SAVE_SEARCH } from '../store/store-mutations';
  import remoteListMixin from '../mixins/remoteListMixin';

  /**
 * Componente de lista con paginación, ordenamiento, y búsqueda
 * en backend
 *
 * Propiedades
 *  * baseApi: string de la URL de la API, a concatenarse luego
 *    de '/api/'.
 *  * headers: Columnas del  data table. Usan las propiedades del Data Table de
 *    Vuetify, con propiedades extras:
 *      - isDate: Poner true si es una fecha
 *      - format(cellValue): Metodo llamado si se desea dar un formato
 *      especial a las celdas de esta columna
 *      - customSortField: Campo que se enviará como query param de orden
 *  * elevation: Number - Elevación de la tabla. Maneja la sombra que tendrá. Debe ser
 *    un entero positivo.
 *
 *
 */

export default {
  name: 'PaginatedList',
  components: {
    GenericForm,
    ErrorMessage
  },
  mixins: [dateFiltersMixin, remoteListMixin, ],
  props: {
    // baseApi: {
    //   type: String,
    //   required: true
    // },
    elevation: {
      type: Number,
      required: false,
      default: () => 0,
      validator: val => val >= 0
    },
    dataSourceUrl: {
      type: String,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    loadingMessage: {
      type: String,
      required: false,
      default: () => 'Cargando'
    },
    errorMessage: {
      type: String,
      required: false,
      default: () => 'No se pudo obtener los registros'
    },
    noDataMessage: {
      type: String,
      required: false,
      default: () => 'No existen registros cargados'
    },
    noSearchResultsMessage: {
      type: String,
      required: false,
      default: () => 'Su búsqueda no obtuvo resultados'
    },
    noSearch: {
      type: Boolean,
      required: false,
      default: () => false
    },
    ignoreSearchField: {
      type: Array,
      required: false,
      default: () => []
    },
    defaultFilters: {
      type: Array,
      required: false,
      default: () => []
    },
    extraQueryParams: {
      type: Object,
      required: false,
      default: () => ({})
    },
    rowActions: {
      type: Array,
      required: false,
      default: () => null
    },
    cargando: {
      type: Boolean,
      default: () => false
    },
    searchDtoUrl: {
      type: String,
      required: false
    },
    saveSearch: {
      type: Boolean,
      default: () => false
    },
    searchKey: {
      type: String
    },
    tooltipTextProp: {
      type: String,
      required: false,
      default: () => null
    },
    rowColor: {
      type: Boolean,
      default: () => false
    },
    rowsPerPageItems: {
      type: Array,
      default: () => [5, 10, 25, ]
    },
    generarCSV: {
      type: Boolean,
      required: false,
      default: () => false
    },
    generarPDF: {
      type: Boolean,
      required: false,
      default: () => false
    },
    urlPDF: {
      type: String,
      required: false,
      default: () => null
    },
    urlCSV: {
      type: String,
      required: false,
      default: () => null
    },
    itemsPerPageDefault: {
      type: Number,
      default: () => 5,
    },
    isPrincipalList: {
      type: Boolean,
      default: () => false,
    },
    selectable: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showAdvanceSearch: false,
    searchFields: null,
    oldAdvanceSearchModel: {},
    advanceSearchModel: {},
    loadingSearchDto: false,
    advanceFilterCount: 0,
    descargando: false,
    totalDescarga: null,
    progresoDescarga: null,
    locale: 'es',
    sheet: false,
    itemClicked: null,
    selected: [],
  }),
  watch: {
    baseApi () {
      this.getAdvanceSearchDto();
      this.search = null;
    },
    pagination: {
      handler () {
        this.getItems();
      },
      deep: true
    },
    search: debounce(function () {
      this.pagination.page = 0;
      this.totalCount = null;
      this.getItems();
      this.storeSearch();
    }, 350),
    advanceSearchModel: {
      deep: true,
      handler () {
        this.storeSearch();
      }
    },
    showAdvanceSearch (val) {
      if (val) {
        this.oldAdvanceSearchModel = Object.assign({}, this.advanceSearchModel);
      }
    },
    dataSourceUrl () {
      this.getItems();
    },
    extraQueryParams: {
      handler () {
        this.getItems();
      },
      deep: true
    },
    defaultFilters: {
      deep: true,
      handler () {
        this.getItems();
      }
    },
    value(val) {
      this.selected = val;
    },
    selected(val) {
      this.$emit('input', val);
    },
  },
  mounted () {
    this.getAdvanceSearchDto();
    const savedSearch = this.getStoredSearch();
    this.search = savedSearch.search;
  },
  methods: {
    descargarCSV () {
      this.descargando = true;
      this.$http
        .get(this.urlCSV || `${this.getBaseApiUrl()}csv`, {
          params: this.getListQueryParams(),
          responseType: 'blob',
          progress (evt) {
            if (evt.lengthComputable) {
              this.progresoDescarga = evt.loaded;
              this.totalDescarga = evt.total;
            }
          }
        })
        .then(r => {
          this.$refs.fileAnchor.download = r.headers
            .get('content-disposition')
            .split(';')
            .find(cd => cd.includes('filename'))
            .split('=')[1]
            .split('"')
            .join(''); // para quitar el caracter "
          return r.blob();
        })
        .then(
          blob => {
            const anchor = this.$refs.fileAnchor;
            anchor.href = URL.createObjectURL(blob);
            anchor.click();
            this.descargando = false;
            this.progresoDescarga = this.totalDescarga = null;
          },
          error => {
            this.descargando = false;
            this.progresoDescarga = this.totalDescarga = null;
          }
        );
    },

    descargarPDF () {
      this.descargando = true;
      this.$http
        .get(this.urlPDF || `${this.getBaseApiUrl()}pdf`, {
          params: this.getListQueryParams(),
          responseType: 'blob',
          progress (evt) {
            if (evt.lengthComputable) {
              this.progresoDescarga = evt.loaded;
              this.totalDescarga = evt.total;
            }
          }
        })
        .then(r => {
          this.$refs.fileAnchor.download = r.headers
            .get('content-disposition')
            .split(';')
            .find(cd => cd.includes('filename'))
            .split('=')[1]
            .split('"')
            .join(''); // para quitar el caracter "
          return r.blob();
        })
        .then(
          blob => {
            const anchor = this.$refs.fileAnchor;
            anchor.href = URL.createObjectURL(blob);
            anchor.click();
            this.descargando = false;
            this.progresoDescarga = this.totalDescarga = null;
          },
          () => {
            this.descargando = false;
            this.progresoDescarga = this.totalDescarga = null;
          }
        );
    },
    getAdvanceSearchDto () {
      if (!this.noSearch) {
        this.loadingSearchDto = true;
        this.$http
          .get(this.getSearchDtoUrl())
          .then(r => r.json())
          .then(
            searchDto => {
              this.searchFields = searchDto;
              const storedSearch = this.getStoredSearch();
              if (storedSearch && storedSearch.advance) {
                this.advanceSearchModel = storedSearch.advance;
                this.calculateAdvanceFilterCount();
              }
              this.loadingSearchDto = false;
            },
            () => {
              this.loadingSearchDto = false;
            }
          );
      }
    },
    getListQueryParams () {
      let params = {
        pageSize:
          this.pagination.itemsPerPage > 0
            ? this.pagination.itemsPerPage
            : this.totalCount
      };
      params['start'] = this.pagination.page > 0 ? (this.pagination.page - 1) * params['pageSize'] : 0;
      params['page'] = this.pagination.page > 0 ? this.pagination.page - 1 : 0;
      params['filter'] = this.search || '';

      if (this.pagination.sortBy && this.pagination.sortBy.length > 0) {
        // Usamos el campo customSortField si existe para el ordenamiento
        var sortHeader = this.headers.find(
          h => this.pagination.sortBy.some(f => f === h.value)
        );

        params['orderBy'] = sortHeader.customSortField || this.pagination.sortBy[0];
        params['orderDesc'] = this.pagination.sortDesc && this.pagination.sortDesc[0];
      }

      params['filters'] = this.defaultFilters.slice();
      for (let searchField in this.advanceSearchModel) {
        if (this.advanceSearchModel[searchField] && this.advanceSearchModel[searchField].length > 0) {
          let fieldInfo = this.searchFields.find(
            s => s.fieldName === searchField
          );
          let filterStringBuild = [
            fieldInfo.modelField,
            Array.isArray(this.advanceSearchModel[searchField])
              ? JSON.stringify(this.advanceSearchModel[searchField])
              : this.advanceSearchModel[searchField]
          ];
          if (fieldInfo.comparator) {
            filterStringBuild.push(fieldInfo.comparator);
            if (fieldInfo.valueDataType) {
              filterStringBuild.push(fieldInfo.valueDataType);
            }
          }
          params['filters'].push(filterStringBuild.join(':'));
        }
      }

      return params;
    },
    onNewButtonClick () {
      this.$router.push({ path: 'nuevo', append: true }).catch(err => {});
    },

    // eslint-disable-next-line
    onRowClick(itemClicked) {
      this.$emit("item-click", itemClicked);
    },

    onRowLongClick(itemClicked) {
      this.itemClicked = itemClicked;
      this.sheet = true;
    },

    storeSearch () {
      if (this.saveSearch && this.searchKey) {
        this.$store.commit(SAVE_SEARCH, {
          componentName: this.searchKey,
          search: {
            search: this.search,
            advance: this.advanceSearchModel
          }
        });
      }
    },

    getStoredSearch () {
      return this.$store.getters.getSearch(this.searchKey);
    },

    clearAdvanceSearch () {
      for (let searchField in this.advanceSearchModel) {
        this.advanceSearchModel[searchField] = null;
      }
      this.$refs.advanceSearchForm.$forceUpdate();
      this.searchAdvance();
    },
    getSearchDtoUrl () {
      return this.searchDtoUrl || this.getBaseApiUrl() + '/searchDto';
    },
    searchAdvance () {
      this.showAdvanceSearch = false;
      this.page = 1;
      this.calculateAdvanceFilterCount();
      this.getItems();
    },

    cancelSearchAdvance () {
      for (let searchField in this.advanceSearchModel) {
        this.advanceSearchModel[searchField] =
          this.oldAdvanceSearchModel[searchField] || null;
      }
      this.$refs.advanceSearchForm.$forceUpdate();
      this.showAdvanceSearch = false;
    },

    /**
     * Formato por defecto de cada celda
     * @param cellValue - string
     * @return string
     */
    defaultRowFormat (cellValue, header) {
      return cellValue !== null
        ? !header.isDate
          ? cellValue
          : this.$options.filters.formatDateFull(cellValue)
        : header.defaultValue || '-';
    },
    calculateAdvanceFilterCount () {
      this.advanceFilterCount = Object.values(this.advanceSearchModel).filter(
        v => Array.isArray(v) ? v.length > 0 : v
      ).length;
    },
    bottonSheetAction (action) {
      if (this.itemClicked) {
        this.$emit('itemAction', { item: this.itemClicked.item, idx: this.itemClicked.index, action: action.name });
      }
    },
    onShowAdvanceSearch() {
      this.showAdvanceSearch = !this.showAdvanceSearch;
    },
  },
  computed: {
    filtersCountText () {
      return this.advanceFilterCount > 0
        ? `${this.advanceFilterCount} filtro${
          this.advanceFilterCount > 1 ? 's' : ''
        }`
        : null;
    },
    porcentajeDescarga () {
      return this.progresoDescarga !== null && this.totalDescarga !== null
        ? this.progresoDescarga / this.totalDescarga
        : 0;
    },
  }
};
</script>

<style>
tr[disabled] {
  opacity: 0.5;
}
</style>
